/* eslint-disable no-unused-vars*/
import React from 'react';
import { HasAccess } from '@permify/react-role';
import { Space, Table, Tag, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { deleteTemplateFighthing } from 'api/templateFighthing';
import { ButtonPrimary, ButtonDelete } from 'common/Button/Button.styles';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { getCookie } from 'helper/cookie';
import Color from 'constants/color';
import moment from 'moment';

const TableTemplateFighthing = (props: any) => {
   const { isLoading, data, renderData, pagination, onChangePage, navigate, token } = props;

   const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));
   const widthMobile = getCookie('widthMobile')
   
   // console.log(data)
   const deleteData = async (id: any) => {
      Swal.fire({
         title: 'คุณแน่ใจว่าจะลบข้อมูลนี้',
         text: 'หากคุณลบแล้วจะไม่แสดงข้อมูลนี้',
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: Color.primaryClick,
         // cancelButtonColor: '#d33',
         cancelButtonText: 'ยกเลิก',
         confirmButtonText: 'ต้องการลบข้อมูล',
         reverseButtons: true,
      }).then(async (result) => {
         if (result.isConfirmed) {
            const deleteData = await deleteTemplateFighthing({ token: token, id });
            const { status, error, message } = deleteData;
            if ( status === 200) {
               Swal.fire({
                  title: 'Successful',
                  text: 'Delete Success',
                  icon: 'success',
                  confirmButtonText: 'Close',
                  showConfirmButton: false,
               });
               renderData();
            } else {
               Swal.fire({
                  title: message,
                  text: 'ไม่สามารถลบข้อมูลนี้ได้',
                  icon: 'error',
                  showConfirmButton: false,
                  confirmButtonText: 'Close',
                  showClass: {
                     popup: 'animate__animated animate__fadeInDown',
                  },
                  hideClass: {
                     popup: 'animate__animated animate__fadeOutUp',
                  },
               });
            }
         }
      });
   };

   // console.log(data)

   const columns: any = [
      {
         title: 'รหัส',
         dataIndex: 'id',
         key: 'id',
         align: 'center',
         width: 70,
      },
     
      {
         title: 'ประเภทหวย',
         key: 'period_name',
         align: 'center',
         width: 150,
         render: (data: any) => {
            return (
               <span>
                  {data?.lottery_type_data?.lottery_type_name}
               </span>
            );
         },
         // responsive: ['sm'],
      },
      // {
      //    title: 'รายละเอียด',
      //    // dataIndex: 'template_limit_detail',
      //    key: 'template_limit_detail',
      //    align: 'center',
      //    width: 150,
      //    render: (data: any) => {
      //       return (
      //          <div dangerouslySetInnerHTML={{ __html: data?.template_limit_detail }} />
      //       )
      //    },
      //    // responsive: ['sm'],
      // },
      {
         title: 'Action',
         align: 'center',
         width: 120,
         render: (data: any) => {
            return ( 
               <Space size={8}>
                  <HasAccess
                     // roles={'Masteradmin'}
                     permissions={['payrate-edit']}
                  >
                     <Tooltip title="แก้ไขข้อมูล">
                        <ButtonPrimary
                           onClick={() => navigate(`/backoffice/template_fighthing/edit/${data.template_fighthing_lottery_type_id}`, { replace: true })}
                           style={{ width: '38px', height: '38px', padding: 0 }}
                        >
                           <EditOutlined />
                        </ButtonPrimary>
                     </Tooltip>
                  </HasAccess>
                  <div style={{ marginTop: '10px' }} />
                  <HasAccess
                     permissions={['payrate-delete']}
                  >
                     <Tooltip title="ลบข้อมูล">
                        <ButtonDelete
                           onClick={() => deleteData(data.id)}
                           style={{ width: '38px', height: '38px', padding: 0 }}
                        >
                           <DeleteOutlined />
                        </ButtonDelete>
                     </Tooltip>
                  </HasAccess>
               </Space>
            );
         },
         // responsive: ['sm'],
      },
   ];

   return (
      <>
         {isMobileView ? (
             <Table
             dataSource={data}
             columns={columns}
             bordered
             loading={isLoading}
             pagination={pagination}
             onChange={onChangePage}
             rowKey="id"
             // size="large"
             // scroll={}
             scroll={{ x: `${widthMobile}`, y: 600}}
          />
         ) : (
            <Table
               dataSource={data}
               columns={columns}
               bordered
               loading={isLoading}
               pagination={pagination}
               onChange={onChangePage}
               rowKey="id"
            />
         )}
      </>
     
   );
};

export default TableTemplateFighthing;
